import { useEffect, useMemo, useRef, useState } from "react";
import "./Detail.scss";
import Header from "../../../../Layout/Header";
import Footer from "../../../../Layout/Footer";
import TTDLocationIcon from "../../../../../common/images/ttd-location-icon.svg";
import { handleStayApiCall } from "../../../../Helpers/apiHelper";
import moment from "moment";
import { Button, CircularProgress, Divider, Link } from "@mui/material";
import WifiIcon from "../../../../../common/images/wifi.svg";
import Carousel from "../../../../Customerpackage/CustomerPackageDetails/RoomSelection/Carousel";
import UserIcon from "../../../../../common/images/user.svg";
import information from "../../../../../common/images/info-circle.svg";
import close from "../../../../../common/images/close.png";
import Verified from "../../../../../common/images/verified.svg";
import {
  loadRatingNumber,
  loadRatingstar,
  showDays,
  showPriceValue,
} from "../../../../Helpers/SettingHelper";
import SearchComponent from "../SearchComponent/SearchComponent";
import { ArrowBackIos as ArrowBackIosIcon } from "@mui/icons-material";
import ShieldIcon from "../../../../../common/images/shield-tick.svg";
import cookie from "react-cookies";
import AlertPopup from "../../../../../common/components/AlertPopup/AlertPopup";
import {
  AmenityIcon,
  EditIcon,
  PolicyIcon,
  StayStarIcon,
} from "../../../../../common/IconList/IconList";
import ModalPopup from "../../../../../common/components/ModalPopup/ModalPopup";
import CancellationPolicy from "../../../../Customerpackage/CustomerPackageDetails/CancellationPolicy/CancellationPolicy";
import MoonIcon from "../../../../../common/images/moon.svg";
import userIcon from "../../../../../common/images/user.svg";
import calendarIcon from "../../../../../common/images/calendar1.svg";
import { isMobile } from "../../../../../utils/util";
import { BottomSheet } from "react-spring-bottom-sheet";
import BottomSearchSheetForList from "../SearchComponent/BottomSearchSheetForList/BottomSearchSheetForList";
import LogoWhite from "../../../../../common/images/logo_white.svg";
import CuratedImg from "../../../../../common/images/Curated_white.svg";
import CustomizeImg from "../../../../../common/images/customize_white.svg";
import MsgImg from "../../../../../common/images/messages.svg";
import TransactionImg from "../../../../../common/images/transaction.svg";
import PriceImg from "../../../../../common/images/price.svg";

const Detail = (props) => {
  let userId = cookie.load("UserId") ? cookie.load("UserId") : "";
  const [userID, setUserID] = useState(userId);
  const [showFareBreakdown, setShowFareBreakdown] = useState(false);
  const [state, setState] = useState(props?.location?.state || {});
  const [selectedHotel] = useState(props?.location?.state?.selectedHotel);
  const [selectedRoom, setSelectedRoom] = useState(
    props?.location?.state?.selectedRoom || []
  );

  // const [hotelResult] = useState([]);
  const [selectedRoomPrice, setSelectedRoomPrice] = useState({});
  const [stayDetail, setStayDetail] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentRoom, setCurrentRoom] = useState(0);
  const [policyReadMore, setPolicyReadMore] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [grandTotal, SetGrandTotal] = useState(0);
  const [triggerLogin, SetTriggerLogin] = useState(false);
  const [openAlertPopup, setOpenAlertPopup] = useState(false);
  const [onlyGuest, setOnlyGuest] = useState(false);
  const [showCancellationPopup, setShowCancellationPopup] = useState(false);
  const [cancellationRules, setCancellationRules] = useState({});
  const [showHotelAmenities, setShowHotelAmenities] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const roomSectionRef = useRef(null);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    calculatePrice();
  }, [selectedRoom]);

  const getData = async () => {
    setIsLoading(true);
    const payload = {
      hotel_id: selectedHotel.hotel_id,
      country: selectedHotel.country_name,
      city: selectedHotel.city_name,
      from_date: moment(state.start_date).format("DD MMM,YYYY"),
      to_date: moment(state.end_date).format("DD MMM,YYYY"),
      passenger_data: state.rooms,
      city_code: selectedHotel.city_code,
    };
    try {
      const response = await handleStayApiCall("post", "getRooms", payload);
      if (response.data?.success) {
        setStayDetail(response.data.data);
        setState({ ...state, selectedHotel: response.data.data });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setAlertMessage(response.data.message);
        setOpenAlertPopup(true);
      }
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const hotelImages = useMemo(() => {
    if (stayDetail) {
      const imageList = stayDetail?.images;
      if (!imageList) return [];

      return imageList
        .map((item, index) => {
          const url = item.url;
          const alt = `${item.category} ${index + 1}`;

          if (url) {
            return { url, alt, label: item.category };
          }

          return null;
        })
        .filter(Boolean); // Remove nulls
    }
  }, [stayDetail]);

  const showRoomPrice = (item, index) => {
    var price = item.room_charges[index]?.room_total_amount;
    return (
      <>{showPriceValue(price, state.currentCurrency, state.currencyRate)}</>
    );
  };

  const selectedRoomPriceIndex = (item, index) => {
    const roomPriceIndex = selectedRoom?.find(
      (room) =>
        parseInt(room?.roomIndex) === parseInt(index) &&
        parseInt(room?.roomMainIndex) === parseInt(currentRoom)
    )?.priceIndex;
    return roomPriceIndex ? showRoomPrice(item, roomPriceIndex) : null;
  };

  const toggleDescription = (readmore) => {
    if (readmore === "about") {
      setIsExpanded((prevState) => !prevState);
    } else if (readmore === "policy") {
      setPolicyReadMore((prevState) => !prevState);
    } else if (readmore === "amenities") {
      //   setAmenitiesReadMore((prevState) => !prevState);
    }
  };

  const sateValChange = (field, value) => {
    if (field === "proceedtocontinue" && value === "Yes") {
      let newuserID = cookie.load("UserId") ? cookie.load("UserId") : "";
      setUserID(newuserID);
      continueBooking(newuserID);
    }
    if (field === "currentCurrency") {
      setState({ ...state, currentCurrency: value });
    }
    if (field === "guest" && value === true) {
      continueBooking(true);
    }
  };

  const selectRoom = (
    roomID,
    roomIndex,
    item,
    roomMainIndex,
    selectedType,
    hotel_name,
    data,
    isRemove
  ) => {
    let selectedRoomPriceID = "";

    const selectedRoomPriceObj = selectedRoomPrice[roomID] || data[roomID];
    if (selectedRoomPriceObj) {
      selectedRoomPriceID = `${selectedRoomPriceObj.priceId}_${selectedRoomPriceObj.index}`;
    }

    if (!selectedRoomPriceID) return;

    const [priceID, priceIndex] = selectedRoomPriceID.split("_");
    const selectedRoomDetails = item.room_charges[priceIndex];
    const existingSelections = selectedRoom || [];
    let updatedSelections = [];

    if (!isRemove) {
      // Remove existing selection from same room group
      updatedSelections = existingSelections.filter(
        (room) => room.roomMainIndex !== roomMainIndex
      );
    } else {
      updatedSelections = [...existingSelections];
    }

    const alreadyExists = updatedSelections.some(
      (room) =>
        room.roomIndex === roomIndex && room.roomMainIndex === roomMainIndex
    );

    if (!alreadyExists && selectedRoomDetails) {
      updatedSelections.push({
        hotel_name,
        roomMainIndex,
        roomIndex,
        room_code: roomID,
        priceID,
        priceIndex,
        room_total_amount: selectedRoomDetails.room_total_amount,
        status: selectedRoomDetails.status,
        rate_description: selectedRoomDetails.rate_description,
        room_type_code: item.room_type_code,
        allocation_details: selectedRoomDetails.allocation_details,
      });
    }
    setSelectedRoom(updatedSelections);
    if (stayDetail?.room_info?.length > currentRoom + 1) {
      setCurrentRoom((prev) => prev + 1);
    }
  };

  const calculatePrice = () => {
    const hotelRooms = stayDetail?.room_info || [];
    let sub_total = 0;

    selectedRoom.forEach((item) => {
      const roomData = hotelRooms[item.roomMainIndex]?.[item.roomIndex];
      const charge = roomData?.room_charges?.[item.priceIndex];

      if (charge?.room_total_amount) {
        sub_total += parseFloat(charge.room_total_amount);
      }
    });

    setSubTotal(sub_total);
    SetGrandTotal(sub_total);
  };

  const goBack = () => {
    props.history.push({
      pathname: props.location.state.prevPath,
      state: props.location.state,
    });
  };

  const continueBooking = (user) => {
    if (selectedRoom.length !== state.rooms.length) {
      setAlertMessage("Select Remaining rooms");
      setShowFareBreakdown(false);
      setOpenAlertPopup(true);
      return false;
    }
    const { hotelDestinationList, selectedHotel, ...searchdata } = state;
    searchdata["destinationWebbedsCity"] = selectedHotel.city_code;
    searchdata["stayOnly"] = true;
    searchdata["ttdOnly"] = false;
    searchdata["onlyGuest"] = onlyGuest;
    const propsData = {
      ...state,
      stayStartDate: state.start_date,
      stayEndDate: state.end_date,
      searchdata,
      selectedHotelID: selectedHotel.hotel_id,
      selectedRoom,
      stayList: [],
      subTotal,
      grandTotal,
      userID,
      onlyGuest,
    };

    if (userID || user) {
      props.history.push({
        pathname: "/booking",
        state: propsData,
      });
    } else {
      setShowFareBreakdown(false);
      setOnlyGuest(true);
      SetTriggerLogin(true);
    }
  };

  const cancellationPolicy = (room, index) => {
    const roomPriceIndex =
      selectedRoom?.find(
        (room) =>
          parseInt(room?.roomIndex) === parseInt(index) &&
          parseInt(room?.roomMainIndex) === parseInt(currentRoom)
      )?.priceIndex ?? 0;
    setCancellationRules(room?.room_charges[roomPriceIndex]);
    setShowCancellationPopup(true);
  };

  return (
    <div className="stay-detail">
      <Header
        {...props}
        sateValChange={sateValChange}
        pagestate={{ ...state, triggerLogin, onlyGuest, SetTriggerLogin }}
      />
      {isLoading && (
        <div className="stay-detail__loader">
          <CircularProgress />
        </div>
      )}
      {!isMobile && (
        <SearchComponent
          state={state}
          disableCity={true}
          setState={setState}
          hideCity={true}
          searchHotels={getData}
        />
      )}
      {stayDetail && (
        <div className="stay-detail-main">
          {!isMobile && (
            <>
              <div className="stay-detail-main__back" onClick={goBack}>
                <ArrowBackIosIcon />
                Back
              </div>
              <div className="stay-detail-main__breadcrumbRow">
                <div className="stay-detail-main__breadcrumbRow__col1">
                  <div className="bread-crumbs pt10">
                    <ul>
                      <li>
                        <a href="/">Home</a>
                      </li>
                      {selectedHotel.city_name && (
                        <li style={{ cursor: "pointer" }}>
                          <a href={`/stay/${selectedHotel.city_name}`}>
                            {selectedHotel.city_name}
                          </a>
                        </li>
                      )}
                      <li>{stayDetail.hotel_name}</li>
                    </ul>
                  </div>
                  <div className="stay-detail-main__breadcrumbRow__col1__pName">
                    {stayDetail.hotel_name}{" "}
                    <div className="stay-detail-main__breadcrumbRow__col1__pName__review">
                      <span className="stay-detail-main__breadcrumbRow__col1__pName__review__number">
                        {loadRatingNumber(stayDetail?.rating)}
                      </span>
                      <span className="stay-detail-main__breadcrumbRow__col1__pName__review__star">
                        {loadRatingstar(stayDetail.rating, "hotel")}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="stay-detail-main__breadcrumbRow__col2">
                  <div className="stay-detail-main__breadcrumbRow__col2__loc">
                    <img src={TTDLocationIcon} alt="TTDLocationIcon" />{" "}
                    <div className="stay-detail-main__breadcrumbRow__col2__loc__txt">
                      {stayDetail.address}, {stayDetail.city_name}
                    </div>
                  </div>
                  <div className="stay-detail-main__breadcrumbRow__col2__review"></div>
                </div>
              </div>
            </>
          )}
          <div className="stay-detail-main__img-container">
            <div className="stay-detail-main__img-container__col1">
              <div className="slider-gallery">
                <Carousel
                  show={false}
                  images={hotelImages}
                  room={stayDetail}
                  height={isMobile ? "200px" : "432px"}
                  showBottomGallery={true}
                />
              </div>
            </div>

            <div className="stay-detail-main__img-container__col2">
              {isMobile && (
                <div className="stay-detail-main__img-container__col2__details">
                  <div className="stay-detail-main__img-container__col2__details__header">
                    <div className="stay-detail-main__img-container__col2__details__header__title">
                      {stayDetail.hotel_name}
                    </div>
                  </div>
                  <div className="stay-detail-main__img-container__col2__details__sRow">
                    <div className="stay-detail-main__img-container__col2__details__sRow__col1">
                      <div className="stay-detail-main__breadcrumbRow__col1__pName__review">
                        <span className="stay-detail-main__breadcrumbRow__col1__pName__review__number">
                          {loadRatingNumber(stayDetail?.rating)}
                        </span>
                        <span className="stay-detail-main__breadcrumbRow__col1__pName__review__star">
                          {loadRatingstar(stayDetail.rating, "hotel")}
                        </span>
                      </div>
                      <div className="stay-detail-main__breadcrumbRow__col2__loc">
                        <img src={TTDLocationIcon} alt="TTDLocationIcon" />{" "}
                        <div className="stay-detail-main__breadcrumbRow__col2__loc__txt">
                          {stayDetail.city_name}
                        </div>
                      </div>
                    </div>
                    <div className="stay-detail-main__img-container__col2__details__sRow__col2">
                      <span onClick={() => setShowBottomSheet(true)}>
                        {state?.adults} Adults
                        {state?.child !== 0 && `| ${state?.child} Childrens`}
                      </span>
                      <EditIcon onClick={() => setShowBottomSheet(true)} />
                    </div>
                  </div>
                </div>
              )}
              <div className="stay-detail-main__img-container__col2__box">
                <div className="stay-detail-main__img-container__col2__box__txtBox">
                  <StayStarIcon /> {stayDetail.rating.split("*").length - 1}
                  -Star Stay
                </div>
                <div className="stay-detail-main__img-container__col2__box__txtBox mv">
                  <AmenityIcon /> {stayDetail?.hotel_amenities?.length}+
                  Amenities{" "}
                </div>
                <div className="stay-detail-main__img-container__col2__box__txtBox">
                  <PolicyIcon /> Non-refundable
                </div>
              </div>
              {!isMobile && (
                <div className="stay-detail-main__img-container__col2__priceBox">
                  <div className="stay-detail-main__img-container__col2__priceBox__header">
                    Enter “FIRSTBOOKING10” to get 10% off
                  </div>
                  <div className="stay-detail-main__img-container__col2__priceBox__content">
                    <div className="stay-detail-main__img-container__col2__priceBox__content__label">
                      Room Starts from
                    </div>
                    <div className="stay-detail-main__img-container__col2__priceBox__content__val">
                      {showPriceValue(
                        state.hotelMinPrice,
                        state.currentCurrency,
                        state.currencyRate
                      )}
                    </div>
                    <Button
                      variant="contained"
                      className="stay-detail-main__img-container__col2__priceBox__content__select"
                      onClick={() =>
                        roomSectionRef.current?.scrollIntoView({
                          behavior: "smooth",
                        })
                      }
                    >
                      Select rooms
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="stay-detail-main__amenityBox" ref={roomSectionRef}>
            <div className="stay-detail-main__amenityBox__title">
              Hotel Amenities
            </div>
            <div className="stay-detail-main__amenityBox__row">
              <div className="stay-detail-main__amenityBox__row__col1">
                {stayDetail.hotel_amenities.slice(0, 3).map((item, index) => (
                  <div
                    className="stay-detail-main__amenityBox__row__col1__txt"
                    key={index}
                  >
                    <img src={WifiIcon} />
                    {item}
                  </div>
                ))}
              </div>
              <div className="stay-detail-main__amenityBox__row__col2">
                <div
                  className="stay-detail-main__amenityBox__row__col2__more"
                  onClick={() => setShowHotelAmenities(true)}
                >
                  View more amenities
                </div>
              </div>
            </div>
          </div>
          <div className="stay-detail-main__content">
            <div className="stay-detail-main__content__col1">
              {Array.isArray(stayDetail?.room_info) &&
                stayDetail?.room_info.length > 0 && (
                  <div className="room-selection-main__header__tabs">
                    {stayDetail?.room_info?.map((item, index) => (
                      <div
                        key={index}
                        id="preferred-room"
                        className={`room-selection-main__header__tabs__tab ${
                          currentRoom === index
                            ? "room-selection-main__header__tabs__active"
                            : ""
                        }`}
                        onClick={() => setCurrentRoom(index)}
                      >
                        Room {parseInt(index) + 1}
                      </div>
                    ))}
                  </div>
                )}
              {/* <div className="stay-detail-main__content__col1__subHead">
                Recommened
              </div> */}
              {stayDetail?.room_info?.length > 0 &&
                stayDetail?.room_info?.map((roomItem, roomIndex) => {
                  return (
                    <ul
                      key={roomIndex}
                      style={{
                        display: currentRoom !== roomIndex ? "none" : "",
                      }}
                    >
                      {roomItem.map((item, index) => {
                        //   var checkRoomSelectionVal = checkRoomSelection(
                        //     index,
                        //     roomIndex
                        //   );
                        var checkRoomSelectionVal = 0;
                        return (
                          <li
                            key={index}
                            //   id={"room_" + roomIndex + "_" + item.room_type_code}
                            className={`${
                              checkRoomSelectionVal > 0
                                ? "active stay-detail-main__content__col1__content__card"
                                : "stay-detail-main__content__col1__content__card"
                            } ${index === 0 && "no-top-radius"}`}
                          >
                            <div className="stay-detail-main__content__col1__content__card__row">
                              <div className="stay-detail-main__content__col1__content__card__row__lhs">
                                <div className="room-parent">
                                  <div className="room-choice-img">
                                    <Carousel
                                      height={"220px"}
                                      show={false}
                                      images={hotelImages}
                                      room={item}
                                      showBottomGallery={false}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="stay-detail-main__content__col1__content__card__row__rhs">
                                <div className="stay-detail-main__content__col1__content__card__row__rhs__title">
                                  {item.room_type_name}
                                </div>
                                <div className="stay-detail-main__content__col1__content__card__row__rhs__rmCapacity">
                                  <img src={UserIcon} alt="user" />{" "}
                                  <span className="stay-detail-main__content__col1__content__card__row__rhs__rmCapacity__label">
                                    Room Capacity{" "}
                                  </span>
                                  {parseInt(item.max_adult) > 0 && (
                                    <span className="stay-detail-main__content__col1__content__card__row__rhs__rmCapacity__pCount">
                                      {parseInt(item.max_adult)} Adult
                                      {parseInt(item.max_adult) > 1 ? "s" : ""}
                                    </span>
                                  )}
                                  {parseInt(item.max_children) > 0 && (
                                    <span className="stay-detail-main__content__col1__content__card__row__rhs__rmCapacity__pCount">
                                      {parseInt(item.max_children)} Child
                                      {parseInt(item.max_children) > 1
                                        ? "s"
                                        : ""}
                                    </span>
                                  )}
                                </div>

                                <div className="details-policy">
                                  <a
                                    href={void 0}
                                    onClick={() =>
                                      cancellationPolicy(item, index)
                                    }
                                  >
                                    <img src={information} alt="info" />
                                    <span>
                                      More details on cancellation policy
                                    </span>{" "}
                                  </a>
                                </div>

                                <div className="stay-detail-main__content__col1__content__card__row__rhs__amenities">
                                  {item.room_amenities !== "" &&
                                    item.room_amenities !== null &&
                                    item.room_amenities
                                      ?.split("#@#")
                                      ?.slice(0, state?.isMobile ? 1 : 2)
                                      ?.map((amenity, index) => (
                                        <div
                                          className="stay-detail-main__content__col1__content__card__row__rhs__amenities__val"
                                          key={index}
                                        >
                                          {amenity.charAt(0).toUpperCase() +
                                            amenity.slice(1)}
                                        </div>
                                      ))}

                                  {item.room_amenities.length > 0 && (
                                    <div
                                      className="stay-detail-main__content__col1__content__card__row__rhs__amenities__val stay-detail-main__content__col1__content__card__row__rhs__amenities__more"
                                      // onClick={() =>
                                      //   handleViewMoreClick(
                                      //     "hotel_info_popup_" +
                                      //       roomIndex +
                                      //       "_" +
                                      //       item.room_type_code
                                      //   )
                                      // }
                                    >
                                      +{" "}
                                      {item.room_amenities?.split("#@#")
                                        ?.length -
                                        (state?.isMobile ? 1 : 2)}{" "}
                                      more
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="stay-detail-main__content__col1__content__card__roomCharges">
                              {item.room_charges.length > 0 && (
                                <>
                                  <div className="stay-detail-main__content__col1__content__card__roomCharges__title">
                                    <img src={information} alt="info" />
                                    Select Extra Options{" "}
                                  </div>
                                  <div className="stay-detail-main__content__col1__content__card__roomCharges__content">
                                    <ul className="stay-detail-main__content__col1__content__card__roomCharges__content__chargeList">
                                      {item.room_charges.map(
                                        (chargeItem, chargeIndex) => {
                                          const selectedRoomObj =
                                            selectedRoom?.find(
                                              (room) =>
                                                parseInt(room.roomMainIndex) ===
                                                  parseInt(roomIndex) &&
                                                room.room_type_code ===
                                                  item.room_type_code
                                            );

                                          return (
                                            <li key={chargeIndex}>
                                              <div>
                                                <input
                                                  type="radio"
                                                  className="room_charge"
                                                  name={`room_charge_${roomIndex}_${item.room_type_code}`}
                                                  data-itemindex={chargeIndex}
                                                  value={`${chargeItem.rate_id}_${chargeIndex}`}
                                                  checked={
                                                    parseInt(
                                                      selectedRoomObj?.priceIndex
                                                    ) === chargeIndex
                                                  }
                                                  onChange={() => {
                                                    const obj = {
                                                      [item.room_type_code]: {
                                                        index: chargeIndex,
                                                        priceId:
                                                          chargeItem.rate_id,
                                                      },
                                                    };

                                                    selectRoom(
                                                      item.room_type_code,
                                                      index,
                                                      item,
                                                      roomIndex,
                                                      checkRoomSelectionVal,
                                                      item.room_type_name,
                                                      obj,
                                                      false
                                                    );
                                                  }}
                                                />
                                                <span>
                                                  {chargeItem.rate_description}
                                                </span>
                                              </div>
                                              <strong>
                                                {showPriceValue(
                                                  chargeItem.room_total_amount,
                                                  state.currentCurrency,
                                                  state.currencyRate
                                                )}
                                              </strong>
                                            </li>
                                          );
                                        }
                                      )}
                                    </ul>
                                  </div>

                                  {selectedRoom?.length > 0 && (
                                    <div className="room-choice-four">
                                      {selectedRoomPriceIndex(item, index) && (
                                        <div className="rcf-lhs">
                                          <p>
                                            <strong className="selected_room_price">
                                              {selectedRoomPriceIndex(
                                                item,
                                                index
                                              )}
                                            </strong>{" "}
                                          </p>
                                          <span>
                                            Total Excludes Taxes and Fees
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  );
                })}
            </div>
            <div className="stay-detail-main__content__col2">
              {selectedRoom?.length > 0 && (
                <>
                  <div className="stay-detail-main__content__col2__priceBox">
                    <div className="stay-detail-main__content__col2__priceBox__content">
                      <div className="stay-detail-main__content__col2__priceBox__content__first">
                        <div className="stay-detail-main__content__col2__priceBox__title">
                          Summary
                        </div>
                        <div className="stay-detail-main__content__col2__priceBox__row">
                          <div className="stay-detail-main__content__col2__priceBox__row__col1">
                            <div className="stay-detail-main__content__col2__priceBox__row__col1__label1">
                              <img src={userIcon} alt="" />
                              Persons
                            </div>
                          </div>
                          <div className="stay-detail-main__content__col2__priceBox__row__col2">
                            <div className="stay-detail-main__content__col2__priceBox__row__col2__val">
                              {state?.adults} Adults
                              {state?.child !== 0 && `| ${state?.child} Child`}
                            </div>
                          </div>
                        </div>
                        <div className="stay-detail-main__content__col2__priceBox__row">
                          <div className="stay-detail-main__content__col2__priceBox__row__col1">
                            <div className="stay-detail-main__content__col2__priceBox__row__col1__label1">
                              <img src={calendarIcon} alt="calendarIcon" />
                              Dates
                            </div>
                          </div>
                          <div className="stay-detail-main__content__col2__priceBox__row__col2">
                            <div className="stay-detail-main__content__col2__priceBox__row__col2__val">
                              {moment(state.start_date).format("DD MMM YYYY")} -{" "}
                              {moment(state.end_date).format("DD MMM YYYY")}
                            </div>
                          </div>
                        </div>
                        <div className="stay-detail-main__content__col2__priceBox__row">
                          <div className="stay-detail-main__content__col2__priceBox__row__col1">
                            <div className="stay-detail-main__content__col2__priceBox__row__col1__label1">
                              <img src={MoonIcon} alt="MoonIcon" />
                              Nights
                            </div>
                          </div>
                          <div className="stay-detail-main__content__col2__priceBox__row__col2">
                            <div className="stay-detail-main__content__col2__priceBox__row__col2__val">
                              {showDays(state.start_date, state.end_date)}{" "}
                              Nights
                            </div>
                          </div>
                        </div>
                      </div>
                      <Divider />
                      <div className="stay-detail-main__content__col2__priceBox__content__first">
                        <div className="stay-detail-main__content__col2__priceBox__title">
                          Stay price breakdown
                        </div>
                        {selectedRoom.map((item, index) => (
                          <>
                            <div
                              className="stay-detail-main__content__col2__priceBox__row"
                              key={index}
                            >
                              <div className="stay-detail-main__content__col2__priceBox__row__col1">
                                <div className="stay-detail-main__content__col2__priceBox__row__col1__label">
                                  Room {item.roomMainIndex + 1}
                                </div>
                                <div className="stay-detail-main__content__col2__priceBox__row__col1__name">
                                  {item.hotel_name}
                                </div>
                                <div className="stay-detail-main__content__col2__priceBox__row__col1__option">
                                  {item.rate_description}
                                </div>
                              </div>
                              <div className="stay-detail-main__content__col2__priceBox__row__col2">
                                <div className="stay-detail-main__content__col2__priceBox__row__col2__price">
                                  {showPriceValue(
                                    item.room_total_amount,
                                    state.currentCurrency,
                                    state.currencyRate
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        ))}
                      </div>
                      <Divider />
                      <div className="stay-detail-main__content__col2__priceBox__total">
                        <div className="stay-detail-main__content__col2__priceBox__total__label">
                          Total price
                        </div>
                        <div className="stay-detail-main__content__col2__priceBox__total__price">
                          {showPriceValue(
                            grandTotal,
                            state.currentCurrency,
                            state.currencyRate
                          )}
                        </div>
                      </div>
                      <div className="stay-detail-main__content__col2__priceBox__action">
                        <Button
                          variant="contained"
                          className="stay-detail-main__content__col2__priceBox__checkoutBtn"
                          onClick={() => continueBooking()}
                        >
                          Checkout here
                        </Button>
                      </div>
                    </div>
                    <div className="stay-detail-main__content__col2__priceBox__footer">
                      <img src={ShieldIcon} alt="shielIcon" />
                      Secure transaction
                    </div>
                  </div>
                  <div className="agree-txt">
                    By clicking "Check out" you agree, that you have read and
                    understood the{" "}
                    <span>
                      <Link to={"/terms-and-conditions"} target="_blank">
                        {" "}
                        Terms & conditions,
                      </Link>{" "}
                      <Link to={"/privacy-policy"} target="_blank">
                        privacy policy
                      </Link>
                      <Link to={"/cancellation-and-refund"} target="_blank">
                        , Cancellation and refund policies.{" "}
                      </Link>
                    </span>{" "}
                  </div>
                </>
              )}
              <div className="why">
                <div className="why__title">
                  Why you should book with{" "}
                  <img src={LogoWhite} alt="LogoWhite" />
                </div>
                <div className="why__row">
                  <div className="why__txt">
                    <img src={CustomizeImg} alt="CustomizeImg" />
                    Hyper customize your vacation
                  </div>
                  <div className="why__txt">
                    <img src={CuratedImg} alt="CuratedImg" /> Curated Vacation
                    from local providers
                  </div>
                  <div className="why__txt">
                    <img src={PriceImg} alt="PriceImage" /> Affordable price
                    &nbsp;&nbsp; <img src={MsgImg} alt="message" />
                    24/7 Support
                  </div>
                  <div className="why__txt">
                    <img src={TransactionImg} alt="Transaction" />
                    Zero transaction fee
                  </div>
                </div>
              </div>
              <div className="stay-detail-main__content__col2__verifiedBox">
                <div className="stay-detail-main__content__col2__verifiedBox__txt">
                  <img src={Verified} alt="Verified" />
                  Approved by Singapore Tourism Board
                </div>
                <div className="stay-detail-main__content__col2__verifiedBox__id">
                  STB TA License
                </div>
                <div className="stay-detail-main__content__col2__verifiedBox__id1">
                  TA03466
                </div>
              </div>
            </div>
          </div>
          <div className="stay-detail-main__box">
            <div className="stay-detail-main__box__header">
              <div className="stay-detail-main__box__header__text">
                Hotel description
              </div>
            </div>
            <div className="stay-detail-main__box__content">
              {isExpanded
                ? stayDetail?.description1
                : stayDetail?.description1.slice(0, 500) + "..."}
              <span onClick={() => toggleDescription("about")}>
                {isExpanded ? "Read Less" : "Read More"}
              </span>
            </div>
            <div className="stay-detail-main__box__header">
              <div className="stay-detail-main__box__header__text">Policy</div>
            </div>
            <div className="stay-detail-main__box__content">
              {stayDetail?.room_info?.map((room) => {
                return room?.map((charge) => {
                  return policyReadMore
                    ? charge?.room_charges[0].tariff_notes
                    : charge?.room_charges[0].tariff_notes.slice(0, 100) +
                        "...";
                });
              })}
              <span onClick={() => toggleDescription("policy")}>
                {policyReadMore ? "Read Less" : "Read More"}
              </span>
            </div>
          </div>
          <div className="stay-detail-main__map">
            <iframe
              width="100%"
              height="400"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src={
                "https://maps.google.com/maps?q=" +
                stayDetail?.latitude +
                "," +
                stayDetail?.longitude +
                "&hl=en&z=14&output=embed"
              }
            ></iframe>
          </div>
        </div>
      )}
      {showHotelAmenities && (
        <ModalPopup
          open={showHotelAmenities}
          handleClose={() => setShowHotelAmenities(false)}
          classNames="common-popup hotel-info-popup"
        >
          <div className="cp-header textcenter">
            <h4>Hotel Amenities</h4>
            <a className="date-package-popup" href={void 0}>
              <img src={close} alt="closeicon" />
            </a>
          </div>
          <div className="cp-body">
            <ul>
              {stayDetail?.hotel_amenities.map((amenity, index) => (
                <li key={index}>{amenity}</li>
              ))}
            </ul>
          </div>
        </ModalPopup>
      )}
      <ModalPopup
        open={showCancellationPopup}
        handleClose={() => setShowCancellationPopup(!showCancellationPopup)}
        classNames="common-popup hotel-moredetails-popup"
      >
        <CancellationPolicy
          state={{
            cancellation_rules: cancellationRules?.cancellation_rules,
            tariff_notes: cancellationRules?.tariff_notes,
          }}
        />
      </ModalPopup>
      {openAlertPopup && (
        <AlertPopup
          open={openAlertPopup}
          handleClose={() => setOpenAlertPopup(false)}
          title="Alert"
          message={alertMessage}
        />
      )}
      <Footer />
      {isMobile && (
        <div className="priceDetail-bottomSheetMain">
          <div className="fareDetails">
            <div className="stay-detail-main__img-container__col2__priceBox__header">
              Enter “FIRSTBOOKING10” to get 10% off
            </div>
            <div className="line"></div>
            <div className="row asst-main">
              {/* {this.itineryTitle() === "Package" &&
                this.state.packageDetails?.creator_package_source !== "uop" && (
                  <div
                    className="asst-cntnr"
                    onClick={() => this.setState({ showAssistanceCard: true })}
                  >
                    <div className="asst-row">
                      <AvatarGroup>
                        <Avatar
                          alt="Surya"
                          src="https://images.fizota.com/Surya-Ravi.webp"
                        />
                        <Avatar
                          alt="Gowtham"
                          src="https://images.fizota.com/Gowtham.webp"
                        />
                        <Avatar
                          alt="Bose"
                          src="https://images.fizota.com/Bose.webp"
                        />
                      </AvatarGroup>
                      <span>Chat, Callback and Free! 1 on 1 Support</span>
                      <img src={AssetChevronRight} alt="AssetChevronRight" />
                    </div>
                  </div>
                )} */}
              {selectedRoom?.length > 0 ? (
                <div className="col-1">
                  <div className="title">
                    Total <span>fare</span>
                  </div>
                  <div className="price">
                    {showPriceValue(
                      grandTotal,
                      state.currentCurrency,
                      state.currencyRate
                    )}
                  </div>

                  <div
                    className="breakdown"
                    onClick={() =>
                      selectedRoom?.length > 0 && setShowFareBreakdown(true)
                    }
                  >
                    View fare breakdown
                  </div>
                </div>
              ) : (
                <div className="col-1">
                  <div className="title">Starts from</div>
                  <div className="price">
                    {showPriceValue(
                      state.hotelMinPrice,
                      state.currentCurrency,
                      state.currencyRate
                    )}
                  </div>
                </div>
              )}
              <div className="col-2">
                <Button
                  className="action"
                  id="processpayment"
                  onClick={() => {
                    if (selectedRoom?.length > 0) {
                      continueBooking();
                    } else {
                      roomSectionRef.current?.scrollIntoView({
                        behavior: "smooth",
                      });
                    }
                  }}
                >
                  {selectedRoom?.length > 0 ? "Check out" : "Select room"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      <BottomSheet
        open={showFareBreakdown}
        onDismiss={() => setShowFareBreakdown(false)}
        className="priceBreakdown__bottomSheetMain stay-detail"
      >
        <div className="stay-detail-main__img-container__col2__priceBox__header">
          Enter “FIRSTBOOKING10” to get 10% off
        </div>
        {selectedRoom?.length > 0 && (
          <div className="stay-detail-main__content__col2__priceBox">
            <div className="stay-detail-main__content__col2__priceBox__content">
              <div className="stay-detail-main__content__col2__priceBox__content__first">
                <div className="stay-detail-main__content__col2__priceBox__title">
                  Price summary
                </div>
                <Divider />
                {selectedRoom.map((item, index) => (
                  <>
                    <div
                      className="stay-detail-main__content__col2__priceBox__row"
                      key={index}
                    >
                      <div className="stay-detail-main__content__col2__priceBox__row__col1">
                        <div className="stay-detail-main__content__col2__priceBox__row__col1__label">
                          Room {item.roomMainIndex + 1}
                        </div>
                        <div className="stay-detail-main__content__col2__priceBox__row__col1__name">
                          {item.hotel_name}
                        </div>
                        <div className="stay-detail-main__content__col2__priceBox__row__col1__option">
                          {item.rate_description}
                        </div>
                      </div>
                      <div className="stay-detail-main__content__col2__priceBox__row__col2">
                        <div className="stay-detail-main__content__col2__priceBox__row__col2__price">
                          {showPriceValue(
                            item.room_total_amount,
                            state.currentCurrency,
                            state.currencyRate
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
              <Divider />
              <div className="stay-detail-main__content__col2__priceBox__total">
                <div className="stay-detail-main__content__col2__priceBox__total__label">
                  Total
                </div>
                <div className="stay-detail-main__content__col2__priceBox__total__price">
                  {showPriceValue(
                    grandTotal,
                    state.currentCurrency,
                    state.currencyRate
                  )}
                </div>
              </div>
              <div className="stay-detail-main__content__col2__priceBox__action">
                <Button
                  variant="contained"
                  className="stay-detail-main__content__col2__priceBox__checkoutBtn"
                  onClick={() => continueBooking()}
                >
                  Check out
                </Button>
              </div>
            </div>
          </div>
        )}
      </BottomSheet>

      {showBottomSheet && (
        <BottomSearchSheetForList
          showBottomSheet={showBottomSheet}
          setShowBottomSheet={setShowBottomSheet}
          show={showBottomSheet}
          setState={setState}
          state={state}
          searchHotels={getData}
          hideCity={true}
          className="detail-bottom-search-sheet"
        />
      )}
    </div>
  );
};

export default Detail;
